import React from 'react';
import PropTypes from 'prop-types';

import Textarea from '@xingternal/malt-text-area';
import { FormattedMessage } from 'react-intl';

import styles from './textSubject.css';

const TextSubject = ({ value, placeholder, errors, submitting, handleChange }) => (
  <Textarea
    value={value}
    name="message"
    placeholder={placeholder}
    label={<FormattedMessage id="SUPPORTHTML_SUB0" />}
    message={errors.message}
    onChange={handleChange('message')}
    className={styles.textarea}
    disabled={submitting}
  />
);

TextSubject.defaultProps = {
  value: '',
  placeholder: '',
};

TextSubject.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  errors: PropTypes.shape({
    message: PropTypes.string,
  }).isRequired,
  submitting: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default TextSubject;
